<a [href]="'http://webphone.att.com/cgi-bin/webphones.pl?id=' + attuid" target="_blank">{{ text || attuid }}</a>